import { useCallback } from 'react'
import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchOrganigrama = (user = null) => {
  const [response, setResponse] = useState(null)
  const [reducido, setReducido] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(() => {
    setLoading(true)
    setError(null)
    axios
      .get(`/organigrama?user=${user?.usuario_web ?? ''}`)
      .then((res) => {
        setResponse(res.data.orgchart)
        setReducido(res.data.reducido ?? '')
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }, [user?.usuario_web])

  useEffect(() => {
    fetchData()
  }, [user, fetchData])

  return { response, reducido, error, loading }
}

export default useFetchOrganigrama
